import { render } from "./UserAvatarComponent.vue?vue&type=template&id=703fe0e5&scoped=true&ts=true"
import script from "./UserAvatarComponent.vue?vue&type=script&lang=ts"
export * from "./UserAvatarComponent.vue?vue&type=script&lang=ts"

import "./UserAvatarComponent.vue?vue&type=style&index=0&id=703fe0e5&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703fe0e5"]])

export default __exports__